import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedLogoutmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.36 1H2.647c-.904 0-1.64.736-1.64 1.64v2.188h1.094V2.641c0-.302.245-.547.546-.547H13.36c.302 0 .547.245.547.547v10.718a.547.547 0 0 1-.547.547H2.647a.547.547 0 0 1-.546-.547v-2.187H1.007v2.187c0 .905.736 1.641 1.64 1.641H13.36c.904 0 1.64-.736 1.64-1.64V2.64C15 1.737 14.264 1 13.36 1Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.956 7.453H3.093L5.17 5.375l-.773-.773L1 8l3.397 3.398.773-.773-2.077-2.078h7.863V7.453Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgOutlinedLogoutmin);
export { ForwardRef as ReactComponent };
